import {Helpers} from "../../../common/js/Helpers";
import Polyfill from "../Polyfill";
import {CartProcessor} from "./CartProcessor";
import {Events} from "./CartEvents";

enum MiniCartMode {
    // eslint-disable-next-line no-unused-vars
    short,
    // eslint-disable-next-line no-unused-vars
    long
}

class MiniCartOptions {
    buttonShowType:string =  'inline';
    emptyCartSelector:string = '.eventgallery-empty-minicart';
    cartSelector:string = '.eventgallery-minicart';
    cartItemsSelector:string = '.cart-items';
    cartItemSelector:string = '.cart-item';
    buttonExpandToggle:string = '.expand-btn';
    buttonDownSelector:string = '.toggle-down';
    buttonUpSelector:string = '.toggle-up';
}

export class MiniCart {
    containerElement: HTMLElement;
    cartElement: HTMLElement;
    cartItemsElement: HTMLElement;
    emptyCartElement: HTMLElement;
    buttonExpandToggleElement: HTMLElement;
    buttonToShort: HTMLElement;
    buttonToLong: HTMLElement;
    options: MiniCartOptions;
    lineItems: any;
    cartProcessor: CartProcessor;
    minicartMode: MiniCartMode = MiniCartMode.short;
    isHoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    activeOverlay:HTMLElement = null;
    hideTimeout: number = null;

    constructor(cartProcessor: CartProcessor, containerElement: HTMLElement, options:MiniCartOptions) {
        this.containerElement = containerElement;
        this.cartProcessor = cartProcessor;
        this.lineItems = [];

        this.options = Helpers.mergeObjects(new MiniCartOptions(), options);
        // @ts-ignore
        let globalConfigStore = window.EventGalleryCartConfiguration;
        this.options = Helpers.mergeObjects(this.options, globalConfigStore);

        this.initUI();

        document.addEventListener(Events.reload, (e: CustomEvent)=>this.updateCartData(e.detail));
        document.addEventListener(Events.rebindAdd2CartButtons, () => {this.updateAdd2CartIcons()})

        let timeout: number = null;
        window.addEventListener('resize', () => {
            if (timeout) window.clearTimeout(timeout);
            timeout = window.setTimeout(() => this.resizeCartArea(this.minicartMode), 500);
        });
    }

    initUI() {
        this.cartElement = this.containerElement?.querySelector(this.options.cartSelector);
        this.cartItemsElement = this.cartElement?.querySelector(this.options.cartItemsSelector);
        this.emptyCartElement = this.containerElement?.querySelector(this.options.emptyCartSelector);
        this.buttonExpandToggleElement = this.cartElement?.querySelector(this.options.buttonExpandToggle);
        this.buttonToShort = this.buttonExpandToggleElement?.querySelector(this.options.buttonUpSelector);
        this.buttonToLong = this.buttonExpandToggleElement?.querySelector(this.options.buttonDownSelector);

        this.buttonExpandToggleElement.addEventListener('click', () => {
            this.minicartMode = this.minicartMode == MiniCartMode.short ? MiniCartMode.long : MiniCartMode.short;
            this.resizeCartArea(this.minicartMode);
            if (this.minicartMode == MiniCartMode.short) {
                this.cartElement.scrollIntoView({behavior: 'smooth'})
            }
        });
    }

    _generateId(lineItem: any) {
        return 'folder=' + encodeURIComponent(lineItem.folder) + '&file=' + encodeURIComponent(lineItem.file);
    }

    updateAdd2CartIcons() {

        let elements = document.querySelectorAll('.eventgallery-add2cart i.egfa');
        for(let i=0; i<elements.length; i++) {
            elements[i].classList.remove('egfa-shopping-cart');
            elements[i].classList.add('egfa-cart-plus');
        }

        // mark the add2cart link to show the item is already in the cart
        for (let i = 0; i<this.lineItems.length; i++) {
            let id = this._generateId(this.lineItems[i])

            let elements = document.querySelectorAll(`.eventgallery-add2cart[data-id*='${id}'] i.egfa`);
            for (let i = 0; i < elements.length; i++) {
                elements[i].classList.add('egfa-shopping-cart');
                elements[i].classList.remove('egfa-cart-plus');
            }
        }
    }

    resizeCartArea(minicartMode:MiniCartMode) {
        let amountOfLines:number = 1;
        let lineHeight = -1;

        let lastY:number = -1;
        let cartElements = this.cartItemsElement.querySelectorAll(this.options.cartItemSelector);
        for(let i = 0; i<cartElements.length; i++) {
            let cartElement: HTMLElement = cartElements[i] as HTMLElement;
            if (lineHeight<0) {
                lineHeight = Helpers.getOuterHeight(cartElement);
            }
            if (lastY>-1 && lastY != cartElement.offsetTop) {
                amountOfLines++
            }
            lastY = cartElement.offsetTop;
        }

        let visibleAmountOfLines = 1;

        if (amountOfLines === 1) {
            this.buttonExpandToggleElement.style.display = 'none';
        } else {
            this.buttonExpandToggleElement.style.display = this.options.buttonShowType;
            if (minicartMode === MiniCartMode.short) {
                this.buttonToLong.style.display = this.options.buttonShowType;
                this.buttonToLong.style.display = this.options.buttonShowType;
                this.buttonToShort.style.display = 'none';
            } else {
                this.buttonToLong.style.display = 'none';
                this.buttonToShort.style.display = this.options.buttonShowType;
                this.buttonToShort.style.display = this.options.buttonShowType;
                visibleAmountOfLines = amountOfLines;
            }
        }

        if(visibleAmountOfLines === 1 && amountOfLines > 1) {
            this.cartItemsElement.style.height = lineHeight + 'px';
        } else {
            this.cartItemsElement.style.height = 'auto';
        }

    }

    updateCartData(data:any) {

        this.lineItems = data.cart;
        if (this.lineItems.length>0) {
            this.cartElement.style.display = 'block';
            if (this.emptyCartElement) this.emptyCartElement.style.display = 'none';
        } else {
            this.cartElement.style.display = 'none';
            if (this.emptyCartElement) this.emptyCartElement.style.display = 'block';
        }

        let cartItemsHTML = '';
        for (let i = this.lineItems.length - 1; i >= 0; i--) {
            cartItemsHTML = cartItemsHTML +
            `<div class="cart-item" data-id="lineitemid=${this.lineItems[i].lineitemid}">
                    ${this.lineItems[i].imagetag}
                    <div class="item-badge">${this.lineItems[i].count}</div>
                    <div class="action-overlay">
                        <button class="action-btn btn-view" title="View image">
                            <i class="egfa egfa-magnifying-glass-plus"></i>
                        </button>
                        <button class="action-btn btn-delete eventgallery-removeFromCart" title="Remove from cart">
                            <i class="egfa egfa-remove"></i>
                        </button>
                    </div>                    
                </div>`;
        }

        this.cartItemsElement.innerHTML = cartItemsHTML;

        this.cartItemsElement.querySelectorAll('.cart-item').forEach((item:HTMLElement) => {
            const overlay: HTMLElement = item.querySelector('.action-overlay');
            const viewBtn: HTMLElement = item.querySelector('.btn-view');
            const deleteBtn: HTMLElement = item.querySelector('.btn-delete');


            // View button opens lightbox
            viewBtn.addEventListener('click', () => {
                item.querySelector('a').click();
            }, true);

            // Delete button removes item
            deleteBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.removeCartItem(item);
            }, true);

            // Mobile: tap to show action overlay
            if (!this.isHoverDevice) {
                item.addEventListener('click', (e: PointerEvent) => {

                    const target = e.target as HTMLElement;
                    if (target.closest('.action-btn')) return; // Let button handle it

                    if (this.activeOverlay && this.activeOverlay !== overlay) {
                        this.activeOverlay.classList.remove('active');
                    }

                    if (!overlay.classList.contains('active')) {
                        e.preventDefault();
                        e.stopPropagation();
                    }

                    overlay.classList.add('active');
                    this.activeOverlay = overlay;

                    if (this.hideTimeout) window.clearTimeout(this.hideTimeout);
                    this.hideTimeout = window.setTimeout(() => {
                        overlay.classList.remove('active');
                        this.activeOverlay = null;
                    }, 3000);
                }, true);
            }
        });

        this.updateAdd2CartIcons();
        this.resizeCartArea(this.minicartMode);

        this.cartElement.querySelector('.item-count').innerHTML =  this.lineItems.length;

        // force the lightbox to rescan the page so we can open cart items in a lightbox.
        // @ts-ignore
        if (Eventgallery !== undefined && Eventgallery.lightbox !== undefined) {
            // @ts-ignore
            Eventgallery.lightbox.reload();
        }
        // tigger the loading of Google Photos images for example.
        document.dispatchEvent(Polyfill.createNewEvent('eventgallery-images-added', {isOverlay: true}));
    }

    removeCartItem(elm: HTMLElement) {
        let reference:string;
        if (elm.getAttribute('data-id')) {
            reference = elm.getAttribute('data-id');
        } else {
            reference = elm.parentElement.getAttribute('data-id');
        }

        this.cartProcessor.remove(reference);
    }
}
